// BarChart.js
import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const BarChart = () => {
  const data = {
    labels: [ 'April 2024', 'May 2024', 'Jun 2024', 'July 2024', 'Aug 2024' ,'Sep 2024' , 'Oct 2024' ,'Nov 2024' , 'Dec 2024'],  
    datasets: [
      {
        label: 'Total Deposits',
        data: [1, 2, 1, 3, 2 , 4, 3, 5 ,4],
        backgroundColor:[
            'rgba(29, 60, 153, 0.2)'
        ],
        borderColor: [
            'rgba(29, 60, 153, 1)'
          ],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: '',
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            return `${context.dataset.label}: ${context.raw}`;
          },
        },
      },
    },
    maintainAspectRatio: false,  
    scales: {
      x: {
        beginAtZero: true,
      },
      y: {
        beginAtZero: true,
      },
    },
  };

  return (
    <div style={{ width: '100% ', height: '310px',   }}>
      <Bar data={data} options={options} />
    </div>
  );
};

export default BarChart;
